import React from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { LocationCards } from './LocationCards';
import { MetricCards } from './MetricCards';
import { RecentPatients } from './RecentPatients';
import { ConversionFunnel } from './ConversionFunnel';
import { LatestSimulation } from './LatestSimulation';
export function DermaClinicDashboard() {
  return <div className="flex h-screen bg-[#04080f] text-[#f0ead8] overflow-hidden font-sans" data-id="element-22">
      <Sidebar data-id="element-23" />

      <main className="flex-1 overflow-y-auto p-8" data-id="element-24">
        <div className="max-w-6xl mx-auto" data-id="element-25">
          <TopBar data-id="element-26" />
          <LocationCards data-id="element-27" />
          <MetricCards data-id="element-28" />

          <div className="grid grid-cols-2 gap-6" data-id="element-29">
            <RecentPatients data-id="element-30" />
            <ConversionFunnel data-id="element-31" />
          </div>

          <LatestSimulation data-id="element-32" />
        </div>
      </main>
    </div>;
}